import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { computed, useSlots } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'BaseInputWrapper',
  props: {
    loading: {
      type: Boolean
    },
    errors: null,
    inline: {
      type: Boolean
    },
    rounded: {
      default: true
    },
    prependText: null
  },
  setup(__props) {
    const props = __props;
    const slots = useSlots();
    const wrapperClasses = computed(() => {
      const result = ["position-relative rounded form-border"];
      if (props.rounded === false) {
        result.push('rounded-0');
      } else if (typeof props.rounded === 'string') {
        result.push(`rounded-${props.rounded}`);
      }
      if (props.loading) {
        result.push('overflow-hidden');
      }
      if (props.errors?.length) result.push('border-danger');
      if (props.inline) result.push('flex-fill');
      return result.join(' ');
    });
    return {
      __sfc: true,
      props,
      slots,
      wrapperClasses
    };
  }
});